import { Dispatch } from "react";
import create from "zustand";

interface TableState {
  cultura: string | null;
  periodo: string | null;
  classeOperacao: string | '';
  expandScreen: boolean;
  queryParams: any;
  porcentagem: number;
  aderenteExec: number;
  naoAderenteExec: number;
  mediaDesvio: number;
  isOpen: boolean;
  details: any;
  tipoPlanejamento: number;
  toleranciaEmDias: number;
  showLegendsRelatorio: boolean;

  setCultura: (args: string | null) => void;
  setPeriodo: (args: string) => void;
  setClasseOperacao: (args: string) => void;
  setExpandScreen: Dispatch<React.SetStateAction<boolean>>;
  setQueryParams: (params: any) => void;
  setAderenteExec: (args: number) => void;
  setNaoAderenteExec: (args: number) => void;
  setPorcentagem: (args: number) => void;
  setMediaDesvio: (args: number) => void;
  setIsOpen: (args: boolean) => void;
  setDetails: (args: any) => void;
  setTipoPlanejamento: (args: number) => void;
  setToleranciaEmDias: (args: number) => void;
  setShowLegendsRelatorio: (args: boolean) => void;
}

const useFilterAvancado = create<TableState>((set) => ({
  cultura: null,
  periodo: null,
  classeOperacao: '',
  expandScreen: false,
  queryParams: {},
  porcentagem: 0,
  aderenteExec: 0,
  naoAderenteExec: 0,
  mediaDesvio: 0,
  isOpen: false,
  details: null,
  tipoPlanejamento: 1,
  toleranciaEmDias: 0,
  showLegendsRelatorio: true,

  setCultura: (cultura) => {
    set(state => ({ cultura }));
  },
  setPeriodo: (periodo) => {
    set(state => ({ periodo }));
  },
  setClasseOperacao: (classeOperacao) => {
    set(state => ({ classeOperacao }));
  },


setExpandScreen: (value) => {
  set((state) => ({
    expandScreen:
      typeof value === "function"
        ? value(state.expandScreen)
        : value,
  }));
},

  setQueryParams: (queryParams) => {
    set(state => ({ queryParams }));
  },

  setAderenteExec: (aderenteExec) => {
    set(state => ({ aderenteExec }));
  },
  setNaoAderenteExec: (naoAderenteExec) => {
    set(state => ({ naoAderenteExec }));
  },
  setPorcentagem: (porcentagem) => {
    set(state => ({ porcentagem }));
  },
  setMediaDesvio: (mediaDesvio) => {
    set(state => ({ mediaDesvio: mediaDesvio }));
  },

  setIsOpen: (isOpen) => {
    set(state => ({ isOpen }));
  },
  setDetails: (details) => {
    set(state => ({ details }));
  },

  setTipoPlanejamento: (tipoPlanejamento) => {
    set(state => ({ tipoPlanejamento }));
  },
  setToleranciaEmDias: (toleranciaEmDias) => {
    set(state => ({ toleranciaEmDias }));
  },

  setShowLegendsRelatorio: (showLegendsRelatorio) => {
    set(state => ({ showLegendsRelatorio }));
  },
 
}));

export default useFilterAvancado;